// extracted by mini-css-extract-plugin
export default {"card":"NotFound_card__owcHC"};